var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7002 17V23C29.7002 24.1935 29.2261 25.3381 28.3822 26.182C27.5383 27.0259 26.3937 27.5 25.2002 27.5H5.7002C4.50672 27.5 3.36213 27.0259 2.51821 26.182C1.6743 25.3381 1.2002 24.1935 1.2002 23V11C1.2002 9.80653 1.6743 8.66193 2.51821 7.81802C3.36213 6.97411 4.50672 6.5 5.7002 6.5H11.7002",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2002 12.5H13.2002",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2002 8C31.1997 9.86187 30.5067 11.657 29.2559 13.0362C28.0052 14.4154 26.2862 15.2801 24.4332 15.462C22.5803 15.644 20.7259 15.1303 19.2307 14.0207C17.7356 12.9112 16.7066 11.2852 16.3439 9.45896C15.9812 7.63276 16.3107 5.73694 17.2684 4.14025C18.2261 2.54356 19.7434 1.36016 21.5253 0.82023C23.3071 0.280301 25.2261 0.422447 26.909 1.21902C28.5918 2.01559 29.9183 3.40964 30.6302 5.13C31.0068 6.03997 31.2005 7.01519 31.2002 8ZM25.4002 6.436C25.6292 6.74294 25.7815 7.10022 25.8442 7.478C25.9094 7.86363 25.8854 8.25905 25.7742 8.634C25.6644 9.00663 25.47 9.34886 25.2062 9.634C24.9508 9.91035 24.6314 10.1198 24.2762 10.244L24.1202 10.3L24.1002 11.7L24.3842 11.626C24.9882 11.4662 25.5398 11.1511 25.9842 10.712C26.4462 10.2589 26.7896 9.69914 26.9842 9.082C27.1797 8.45994 27.2216 7.79977 27.1062 7.158C26.9964 6.53054 26.7287 5.94137 26.3282 5.446L27.4502 4.246L24.3382 4.3L24.2922 7.632L25.4002 6.436ZM21.0742 10.546L19.9502 11.746L23.0642 11.7L23.1062 8.366L21.9982 9.554C21.7692 9.24707 21.617 8.88978 21.5542 8.512C21.4895 8.12702 21.5134 7.73233 21.6242 7.358C21.7366 6.98531 21.9337 6.64372 22.2002 6.36C22.4562 6.08331 22.7762 5.87383 23.1322 5.75L23.2962 5.692L23.3142 4.292L23.0302 4.366C22.4265 4.52527 21.8749 4.83967 21.4302 5.278C20.9682 5.73107 20.6248 6.29086 20.4302 6.908C20.2348 7.53008 20.1929 8.19022 20.3082 8.832C20.418 9.45946 20.6858 10.0486 21.0862 10.544L21.0742 10.546Z",
    fill: "#2C4C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckBalance);
export default __webpack_public_path__ + "static/media/ic_check_balance.5df8b5df048d55e641400eeabf0cc4f2.svg";
export { ForwardRef as ReactComponent };